import Appointment from "Pages/Appointment/Appointment";
import React from "react";
import icons from "../Common/Icons";
import { DashboardMenu, AssessmentMenu, AppointmentMenu, HealthProfileMenu, MyProfileIcon,MyOrderIcon, 
         DocUpload,SubscriptionPlan,MyAvailabilityIcon, MyPatientIcon, CareAdminDashboardMenu, MyTicketIcon,
          AllTicketIcon, PatientRecordIcon, ConsultationIcon, SettingsMenu , AddMedicine,CouponMenuGray, AnalysticsIcon,VendorIcon,BillingIcon,VitalIcon} from "Common/ReactIcons";
import MyAvailabilityNewVersion from "Pages/MyProfile/MyAvailabilityNewVersion";
import MedicineList from "Pages/Prescription/MedicineList";
import ManageCoupon from "Pages/Prescription/ManageCoupon";
import OfflinePatientRegister from "Pages/Authentication/OfflinePatientRegister";
import ReleaseNote from "ReleaseNote/latestreleasenote/ReleaseNote";
import VitalForm from "Pages/VitalForm/VitalForm";
import VitalFormCareAdmin from "Pages/VitalForm/VitalFormCareAdmin";
import MyAvailabilitySwitch from "Pages/MyProfile/MyAvailabilitySwitch";
import PatientDetailNew from "Pages/Patient/PatientDetailNew";
import MyAllPatients from "Pages/Patient/MyAllPatients";
import Billing from "Pages/Billing/Billing";
import EditBilling from "Pages/Billing/EditBilling";
import Vendor from "Pages/Billing/Vendor/Vendor";
import ChimeVideoConsultation from "Pages/Consultation/ChimeVideoConsultation";
import TicketsDashboard from "Pages/SuperAdminNew/TicketsDashboard";
import SuperAdminDashboard from "Pages/SuperAdminNew/SuperAdminDashboard";
import Clinicians from "Pages/SuperAdminNew/Clinicians";
import EditClinician from "Pages/SuperAdminNew/EditClinician";
import UserManagement from "Pages/SuperAdminNew/UserManagement/UserManagement";
import EditUser from "Pages/SuperAdminNew/UserManagement/EditUser";
import AIFormAssistant from "Pages/Consultation/AIForm/AIFormAssistant";
const Landing = React.lazy(() => import("Pages/LandingPage/Landing"));
const Assessment = React.lazy(() => import("Pages/Assessment/Assessment"));

const GuestUserAuth = React.lazy(() =>
  import("Pages/LandingPage/GuestUserAuth")
);
const MyAppointment = React.lazy(() =>
  import("Pages/Appointment/MyAppointment")
);
const AssessmentHistory = React.lazy(() =>
  import("Pages/Assessment/AssessmentHistory")
);
const ConsultationHistory = React.lazy(() =>
  import("Pages/Consultation/ConsultationHistory")
);
const MyPatient = React.lazy(() => import("Pages/Patient/MyPatientHome"));
const MyPatientDetail = React.lazy(() => import("Pages/Patient/MyPatient"));
const PHISummary = React.lazy(() => import("Pages/PHI/PHISummary"));
const ShortendForm = React.lazy(() => import("Pages/PHI/ShortHandForm/ShortHandForm"));
const NewHealthProfile = React.lazy(()=> import("Pages/PHI/ShortHandForm/NewHealthProfile"))
const Dashboard = React.lazy(() => import("Pages/Dashboard/Dashboard"));
const ScheduleAppointment = React.lazy(() =>
  import("Pages/Appointment/ScheduleAppointment")
);
const MyAvailability = React.lazy(() =>
  import("Pages/MyProfile/MyAvailability")
);

const MyProfile = React.lazy(() => import("Pages/MyProfile/MyProfile"));
const MyProfileChild = React.lazy(() => import("Pages/MyProfile/MyProfileChild"));
const AssessmentType = React.lazy(() => import("Pages/Assessment/SelectAssessmentType"));
const AssessmentScoreDetails = React.lazy(() => import("Pages/Assessment/AssessmentScoreDetails"));
const BookAppointment = React.lazy(() => import("Pages/Appointment/BookAppointment"));
const PatientDetail = React.lazy(() => import("Pages/Patient/PatientDetail"));
const CareAdmin = React.lazy(() => import("Pages/CareAdmin/CareAdmin"));
const TicketList = React.lazy(() => import("Pages/CareAdmin/TicketList"));
const SearchPatient = React.lazy(() => import("Pages/CareAdmin/SearchPatient"));
const PatientLists = React.lazy(() => import("Pages/CareAdmin/PatientLists"));
const PlanWise = React.lazy(()=> import("Pages/CareAdmin/PlanWiseStatistics"));
const PlanHistory = React.lazy(()=> import("Pages/CareAdmin/PlanHistory"));
const NewSelectAssessmentType = React.lazy(()=> import("Pages/Assessment/NewSelectAssessmentType"));



// const VideoConsultation = React.lazy(() =>
//   import("Pages/Consultation/VideoConsultation")
// );
const VideoConsultation = React.lazy(() =>
  import("Pages/Consultation/ChimeVideoConsultation")
);
const PatientRecord = React.lazy(() => import("Pages/CareAdmin/PatientRecord"));
const NewOfflinePatient = React.lazy(() => import("Pages/CareAdmin/NewOfflinePatient"));
const PatientConsultation = React.lazy(() => import("Pages/CareAdmin/ConsultationHistory"));
const ConsultationList = React.lazy(() =>
  import("Pages/CareAdmin/ConsultationList")
);
const MyTickets = React.lazy(() => import("Pages/CareAdmin/MyTickets"));
const B2BRecords = React.lazy(() => import("Pages/CareAdmin/B2Brecords"))
const AnalyticsIframe = React.lazy(() => import("Pages/CareAdmin/Analytics"))
const PaymentView = React.lazy(() => import("Pages/Payment/PaymentViewThirdVersion"));
// const PaymentView = React.lazy(() => import("Pages/Payment/PaymentViewSecondVersion"));
const Subscription = React.lazy(() => import("Pages/Payment/Subscription"));
const Coupon = React.lazy(() => import("Pages/Payment/Coupon"));
const CareChatPage = React.lazy(() => import("Pages/Chat/CareChatPage"));
const CareAdminDomainDashboard = React.lazy(() =>
  import("Pages/CareAdmin/CareAdminDomainDashboard")
);
const SuperAdmin = React.lazy(() => import("Pages/SuperAdmin/SuperAdminRole"));
const AddService = React.lazy(() => import("Pages/SuperAdmin/AddService"));
const Authentication = React.lazy(() => import("Pages/Authentication/Authentication"));
const SwitchAccount = React.lazy(() => import("Pages/Authentication/SwitchAccount"));
const CorporateDashboard = React.lazy(() => import("Pages/CoOrperateAdmin/CorporateDashboard"))
const CorporateTable = React.lazy(() => import("Pages/CoOrperateAdmin/CorporateTable"))
const UploadFile = React.lazy(() => import("Pages/CoOrperateAdmin/UploadFile"))
const AccountProfiles = React.lazy(() => import("Pages/Authentication/AccountProfiles"))
const RoleSelection = React.lazy(() => import("Pages/Authentication/RoleSelection"))
const PrivacyPolicy = React.lazy(() => import("Pages/Others/PrivacyPolicy"))
const TermsofUse = React.lazy(() => import("Pages/Others/TermsofUse"))
const MyOrders = React.lazy(() => import("Pages/Payment/MyOrders"))
const MedicalDocument = React.lazy(() => import ("Pages/Patient/MedicalDocument"))
const FunnelingQuestions = React.lazy(()=>import("Pages/Authentication/Funneling Questions/FunnelingQuestions"))
const DoctorFollowUpTickets = React.lazy(()=>import ("Pages/Others/DoctorFollowUpTicket"))

export const LoggedUserRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <Dashboard {...props} />,
  },
  // {
  //   path: "/video-consultation",
  //   render: (props) => (<VideoConsultation {...props} />),
  // },
  {
    path: "/video-consultation",
    render: (props) => (<ChimeVideoConsultation {...props} />),
  },
  // {
  //   path: "/assessment-history",
  //   label:"Assessments",
  //   value: "assessment-history",
  //   icon: <AssessmentMenu />,
  //   showmenu: true,
  //   render: (props) => <AssessmentHistory {...props} />,
  // },
  {
    path: "/health-profile",
    icon:<HealthProfileMenu/>,
    showmenu: true,
    label: "Health Record",
    value: "health-profile",
    render: (props) => <NewHealthProfile {...props} />,
  },  
  {
    path: "/document-upload",
    icon: <DocUpload />,
    showmenu: true,
    label: "Document Upload",
    value: "document-upload",
    render: (props) => <MedicalDocument {...props} />,
  },
  {
    path: "/schedule-appointment",
    render: (props) => <Appointment {...props} />,
  },
  {
    icon:<AppointmentMenu />,
    showmenu: true,
    path: "/consultation-history",
    label: "Appointments",
    value: "consultation-history",
    render: (props) => <ConsultationHistory {...props} />,
  },
  {
    icon:<VitalIcon />,
    showmenu: true,
    path: "/vital-form",
    label: "Vitals",
    value: "vital-form",
    render: (props) => <VitalForm {...props} />,
  },
  // {
  //   path: "/select-assessment",
  //   render: (props) => <AssessmentType {...props} />,
  // },
  // {
  //   path: "/new-select-assessment",
  //   render: (props) => <NewSelectAssessmentType {...props} />,
  // },
  {
    path: "/detailed-health-profile",
    render: (props) => <PHISummary {...props} />,
  },
  // {
  //   path: "/take-assessment",
  //   render: (props) => <Assessment {...props} />,
  // },
  {
    path: "/score-details",
    render: (props) => <AssessmentScoreDetails {...props} />,
  },
  {
    path: "/select-doctor",
    render: (props) => <BookAppointment {...props} />,
  },
  {
    path: "/paymentView",
    render: (props) => <PaymentView {...props} />,
  },{
    path: "/my-account",
    render: (props) => <MyProfile {...props} />,
  },
];
export const SettingsRoutesCase1 = [{
  path: "/Settings",
  label:"Settings",
  value:"settings",
  icon: <SettingsMenu />,
  showmenu: true,
  children: [
    {
      path: "/release-note",
      label: "Release Notes",
      value: "release-note",
      render: (props) => <ReleaseNote {...props} />,
    },
    {
      path: "/profile-lists",
      label: "Switch Account",
      value: "profile-lists",
      render: (props) => <AccountProfiles {...props} />,
    },
    {
      path: "/my-account",
      label: "My Profile",
      value: "my-account",
      render: (props) => <MyProfile {...props} />,
    },
    // {
    //   key:"logout",
    //   label:"Logout",
    //   value:"logout"
    // }
  ],
  },
]
export const SettingsRoutesCase2 = [{
  path: "/Settings",
  label:"Settings",
  value:"settings",
  icon: <SettingsMenu />,
  showmenu: true,
  children: [
    {
      path: "/release-note",
      label: "Release Notes",
      value: "release-note",
      render: (props) => <ReleaseNote {...props} />,
    },
    {
      path: "/profile-lists",
      label: "Switch Account",
      value: "profile-lists",
      render: (props) => <AccountProfiles {...props} />,
    },
    {
      path: "/my-account-child",
      label: "My Profile",
      value: "my-account-child",
      render: (props) => <MyProfileChild {...props} />,
    },
    // {
    //   key:"logout",
    //   label:"Logout",
    //   value:"logout"
    // }
  ],
  },
]
export const SettingsDoctorRoutes = [{
  path: "/Settings",
  label:"Settings",
  value:"settings",
  icon: <SettingsMenu />,
  showmenu: true,
  children: [
    {
      path: "/my-account",
      label: "My Profile",
      value: "my-account",
      render: (props) => <MyProfile {...props} />,
    },
    {
      path: "/my-availability",
      label: "My Availability",
      value: "my-availability",        
      render: (props) => <MyAvailabilitySwitch {...props} />,
    },
    // {
    //   key:"logout",
    //   label:"Logout",
    //   value:"logout"
    // }
  ],
  },
  // {
  //   icon: <SettingsMenu />,
  //   showmenu: true,
  //   path: "/my-account",
  //   label: "My Profile",
  //   value: "my-account",
  //   render: (props) => <MyProfile {...props} />,
  // },
]
export const LogoutRoutes = [{
  path: "/Settings",
  label:"Settings",
  value:"settings",
  icon: <SettingsMenu />,
  showmenu: true,
  children: [
    {
      key:"logout",
      label:"Logout",
      value:"logout"
    }
  ],
  },
]

export const DoctorRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <Dashboard {...props} />,
  },  
  // {
  //   path: "/my-availability",
  //   icon: <MyAvailabilityIcon/> ,
  //   showmenu: true,
  //   label: "My Availability",
  //   value: "my-availabilities",
  //   children: [
  //     {
  //       path: "/my-availability",
  //       label: "My Availability",
  //       value: "my-availability",        
  //       render: (props) => <MyAvailability {...props} />,
  //     },
  //     {
  //       path: "/my-availability-new-version",
  //       label: "My Availability (Beta Version)",
  //       value: "my-availability-new-version",
  //       render: (props) => <MyAvailabilityNewVersion {...props} />,
  //     }
  //   ],
  // },
  // {
  //   path: "/instructions",
  //   icon: <HealthProfileMenu/>,
  //   label: "Instructions",
  //   value: "instructions",
  //   showmenu: true,
  //   render: (props) => <DoctorFollowUpTickets {...props} />,
  // },
  {
    path: "/my-account",
    icon: <MyProfileIcon />,
    showMenu: false,
    children: [
      {
        path: "/my-account",
        label: "My Profile",
        value: "my-account",
        render: (props) => <MyProfile {...props} />,
      },
      {
        path: "/my-availability",
        label: "My Availability",
        value: "my-availability",        
        render: (props) => <MyAvailabilitySwitch {...props} />,
      },
    ],
  },
  {
    path: "/video-consultation",
    render: (props) => (<VideoConsultation {...props} />),
  },
  // {
  //   path: "/assessment-history",
  //   render: (props) => <AssessmentHistory {...props} />,
  // },
  {
    path: "/health-profile",
    render: (props) => <PHISummary {...props} />,
  },
  {
    path: "/document-upload",
    render: (props) => <MedicalDocument {...props} />,
  },
  {
    path: "/patient-detail",
    render: (props) => <PatientDetailNew {...props} />,
  },
  {
    path: "/my-patientsdetails", 
    value: "my-patientsdetails",
    selectedMenu: "my-patients",
    render: (props) => <MyPatientDetail {...props} />,
  },
  {
    path:"/ai-form-assistant",
    render:(props) => <AIFormAssistant {...props} />
  }
];

export const DoctorRoutesBase={
  "my_appointments": {
    path: "/appointments",
    icon: <AppointmentMenu />,
    showmenu: true,
    label: "My Appointments",
    value: "appointments",
    render: (props) => <MyAppointment {...props} />,
  },
  "my_patients": {
    path: "/my-patients",
    icon: <MyPatientIcon/>,
    label: "My Patients",
    value: "my-patients",
    showmenu: true,
    // render: (props) => <MyPatient {...props} />,
    render: (props) => <MyAllPatients {...props} />,
  }
}
export const CareAdminRoutes = [
  // {
  //   path: "/patient-plan",
  //   icon: <PatientRecordIcon/> ,
  //   showmenu: true,
  //   label: "Patient Records",
  //   value: "patient-plan",
  //   render: (props) => <PlanWise {...props} />,
  // },  
  // {
  //   path: "/org-records",
  //   icon: <MyPatientIcon/> ,
  //   showmenu: true,
  //   label: "B2B Records",
  //   value: "org-records",
  //   render: (props) => <B2BRecords {...props} />,
  // },
 
  {
    path: "/chat",
    icon: icons.patient_records,
    showmenu: false,
    label: "Chat",
    value: "chat",
    render: (props) => <CareChatPage {...props} />,
  },
  {
    path: "/patient-lists",
    render: (props) => <PatientLists {...props} />,
  },
  {
    path:"/plan-history",
    render: (props)=> <PlanHistory {...props}/>,
  },
  {
    path: "/patient-plan",
    render: (props) => <PlanWise {...props} />,
  },
  {
    path: "/my-tickets",
    render: (props) => <MyTickets {...props} />,
  },
  {
    path: "/patient-records",
    render: (props) => <PatientRecord {...props} />,
  },
  {
    path: "/new-user",
    render: (props) => <NewOfflinePatient {...props} />,
  },
  {
    path: "/care-admin-domain",
    render: (props) => <CareAdminDomainDashboard {...props} />,
  },
  {
    path: "/patient-consultation",
    render: (props) => <PatientConsultation {...props} />,
  },
  {
    path: "/vital-form",
    render: (props) => <VitalFormCareAdmin {...props} />,
  },
  {
    path: "/edit-bill",
    render: (props) => <EditBilling {...props} />,
  },
];

export const CareAdminRoutesBase={
  "all_tickets":{
    path: "/tickets-list",
    icon: <AllTicketIcon/>,
    showmenu: true,
    label: "All Tickets",
    value: "tickets-list",
    render: (props) => <TicketList {...props} />,
  },
  "my_tickets":{
    path: "/select-tickets",
    icon: <MyTicketIcon/> ,
    showmenu: true,
    label: "My Tickets",
    value: "select-tickets",
    render: (props) => <CareAdmin {...props} />,
  },
  "patients":{
    path: "/search-patient",
    icon: <PatientRecordIcon/> ,
    showmenu: true,
    label: "Patients",
    value: "search-patient",
    render: (props) => <SearchPatient {...props} />,
  },
  "clinicians":{
    path: "/doctor-availabilty",
    icon: <ConsultationIcon/> ,
    showmenu: true,
    label: "Doctors",
    value: "doctor-availabilty",
    render: (props) => <MyAvailabilityNewVersion {...props} />,
  },
  "medicines":{
    path: "/add-medicine",
    icon: <AddMedicine/> ,
    showmenu: true,
    label: "Medicines",
    value: "add-medicine",
    // render: (props) => <FormAddMedicine {...props} from="care-admin" />,
    render: (props) => <MedicineList {...props} from="care-admin" />,
  },
  "offline_registration":{
    path: "/offline-patient-register",
    icon: <MyPatientIcon />,
    showmenu: true,
    label: "Offline Registration",
    value: "offline-patient-register",
    render: (props) => <OfflinePatientRegister {...props} />,
  },
  "consultations":{
    path: "/consultation-list",
    icon: <AppointmentMenu /> ,
    showmenu: true,
    label: "Consultations",
    value: "consultation-list",
    render: (props) => <ConsultationList {...props} />,
  },
  "billing":{
    path: "/billing",
    icon: <BillingIcon />,
    showmenu: true,
    label: "Billing",
    value: "billing",
    render: (props) => <Billing {...props} />,
  },
  "vendor":{
    path: "/search-vendor",
    icon: <VendorIcon />,
    showmenu: true,
    label: "Vendors",
    value: "search-vendor",
    render: (props) => <Vendor {...props} />,
  },  
  "coupons":{
    path: "/manage-coupon",
    icon: <CouponMenuGray/> ,
    showmenu: true,
    label: "Manage Coupons",
    value: "manage-coupon",
    // render: (props) => <FormAddMedicine {...props} from="care-admin" />,
    render: (props) => <ManageCoupon {...props} from="care-admin" />,
  },    
}

export const CareAdminDomainRoutes= [{
  path: "/care-admin-domain",
  render: (props) => <CareAdminDomainDashboard {...props} />
}]
export const ROLE_ROUTES= [{
  path: "/select-role",
  render: (props) => <RoleSelection {...props} />
}]

export const GuestUserRoutes = [
  {
    path: "/dashboard",
    render: (props) => <Landing {...props} />,
  },
  // {
  //   path: "/take-assessment",
  //   render: (props) => <Assessment {...props} />,
  // },
  // {
  //   path: "/assessment-completion",
  //   render: (props) => <GuestUserAuth {...props} />,
  // },
  {
    path: "/login",
    render: (props) => <Authentication {...props} />,
  },
  {
    path: "/switch-account",
    render: (props) => <SwitchAccount {...props} />,
  },
  {
    path: "/privacy-policy",
    target: "_blank",
    render: (props) => <PrivacyPolicy {...props} />,
  },
  {
    path: "/terms-of-use",
    target: "_blank",
    render: (props) => <TermsofUse {...props} />,
  },
  // {
  //   path: "/funneling-questions",
  //   render: (props) => <FunnelingQuestions {...props} />,
  // },
  // {
  //   path: "/new-select-assessment",
  //   render: (props) => <NewSelectAssessmentType {...props} />,
  // },  
  // {
  //   path: "/release-note",
  //   render: (props) => <ReleaseNote {...props} />,
  // },
];

export const SubscriptionPlanRoutes = [
  {
    path: "/subscription-plan",
    icon: <SubscriptionPlan />,
    showmenu: true,
    label: "Membership",
    value: "subscription-plan",
    render: (props) => <Subscription {...props} />,
  },  
  {
    path: "/my-order",
    icon: <MyOrderIcon />,
    showmenu: true,
    label: "Order History",
    value: "my-order",
    render: (props) => <MyOrders {...props} />,
  },
  {
    path: "/coupon-apply",
    render: (props) => <Coupon {...props} />,
  },
];

export const SuperAdminRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <SuperAdminDashboard {...props} />,
  },  
  {
    path: "/edit-user",
    render: (props) => <EditUser {...props} />,
  },
  {
    path: "/clinician-check-availability",
    render: (props) => <MyAvailability {...props} />,
  },
]
export const SuperAdminRoutesBase ={
  "ticket_management": {
    path: "/tickets",
    icon: <AllTicketIcon />,
    showmenu: true,
    label: "Tickets",
    value: "tickets",
    render: (props) => <TicketsDashboard {...props} />,
  },
  "user_management":{
    path: "/user-management",
    icon: <ConsultationIcon />,
    showmenu: true,
    label: "User Management",
    value: "user-management",
    render: (props) => <UserManagement {...props} />,
  },
}
export const CorperateAdminRoutes = [
  {
    path: "/dashboard",
    icon: <DashboardMenu />,
    showmenu: true,
    label: "Dashboard",
    value: "dashboard",
    render: (props) => <CorporateDashboard {...props} />,
  },   
  {
    path: "/table",
    icon: <MyPatientIcon/>,
    showmenu: true,
    label: "Records",
    value: "table",
    render: (props) => <CorporateTable {...props} />,
  },
  // {
  //   path: "/Upload",
  //   icon: <img src={icons.new_corporate_admin_upload} />,
  //   showmenu: true,
  //   children: [
  //     {
  //       path: "/uplaod-data",
  //       label: "Create Account",
  //       value: "upload_data",
  //       render: (props) => <UploadFile {...props} />,
  //     },
  //   ],
  // },
]
